var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkGal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5903 15.3034L9.41177 16.4819C7.78459 18.1091 5.1464 18.1091 3.51922 16.4819C1.89203 14.8547 1.89203 12.2165 3.51922 10.5893L4.69773 9.4108M15.3043 10.5893L16.4828 9.4108C18.11 7.78361 18.11 5.14542 16.4828 3.51824C14.8557 1.89106 12.2175 1.89106 10.5903 3.51824L9.41177 4.69675M7.08436 12.9167L12.9177 7.08337",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkGal);
export default __webpack_public_path__ + "static/media/link_gal.99d8ef184f02add0b17f34ba7afbbc33.svg";
export { ForwardRef as ReactComponent };